import React from "react";
import shapeImage from "../../img/cuberightb.png"; // Replace with your image path

const index = () => {
  return (
    <div className=" min-h-screen bg-[radial-gradient(89.62%_213.03%_at_38.75%_80.3%,#07031C_0%,#241D4A_30.52%,#07031C_64.32%)] text-white px-6 py-16 md:px-24 overflow-hidden">
      {/* Decorative Image */}
      <img
        src={shapeImage}
        alt="Decorative Crypto Shape"
        className="absolute bottom-4 right-4 w-32 md:w-48 opacity-80 pointer-events-none select-none"
      />

      {/* Header Section */}
      <div className="mb-16">
        <h2 className="text-white font-bold text-[28px] md:text-[52px] font-lato leading-[1.2] md:leading-[1.1] text-left">
          Welcome to <br />
          <span className="text-[#F2C493] font-lato">Capital Nest</span>
        </h2>
        <p className="mt-4 font-istok text-[16px] md:text-[18px] text-left text-white max-w-2xl">
          At Capital Nest, we believe that everyone should have the freedom to earn, hold, and invest their money in cryptocurrency without any hassle – no matter their level of understanding of cryptocurrency.
        </p>
      </div>

      {/* Mission and Forte Section */}
      <div className="grid md:grid-cols-2 gap-10 text-left">
        {/* Mission */}
        <div>
          <h3 className="text-[#F2C493] text-[24px] md:text-[32px] font-bold mb-4 font-lato">Our Mission</h3>
          <p className="text-[16px] md:text-[18px] text-white max-w-md font-lato">
            At Capital Nest, we believe that everyone should have the freedom to earn, hold, and invest their money in cryptocurrency without any hassle – no matter their level of understanding of cryptocurrency.
          </p>
          <button className="mt-8 bg-gradient-to-r from-[#F2C26B] to-[#2F263D] text-white px-6 py-3 rounded-md font-medium shadow-md hover:opacity-90 transition duration-300">
            Get Started
          </button>
        </div>

        {/* Forte */}
        <div>
          <h3 className="text-[#F2C493] text-[24px] md:text-[32px] font-bold mb-4 font-lato">Our Forte</h3>
          <p className="text-[16px] md:text-[18px] text-white max-w-md font-lato">
            At Capital Nest, we believe that everyone should have the freedom to earn, hold, and invest their money in cryptocurrency without any hassle – no matter their level of understanding of cryptocurrency.
          </p>
        </div>
      </div>
    </div>
  );
};

export default index;
